import { z } from 'zod';

export const activityScanFieldTypeSchema = z.enum(['TOGGLE', 'TEXT', 'BARCODE']);

export const activityScanFieldSchema = z.object({
  id: z.string().min(1).max(40),
  label: z.string().min(1).max(120),
  type: activityScanFieldTypeSchema,
  required: z.boolean().optional().default(false),
  placeholder: z.string().max(200).optional(),
});

export const activityScanFieldsSchema = z.array(activityScanFieldSchema).max(20);

export const duplicateScanBehaviorSchema = z.enum(['REJECT', 'CREATE_NEW', 'UPDATE_EXISTING']);

export type ActivityScanField = z.infer<typeof activityScanFieldSchema>;
export type ActivityScanFieldType = z.infer<typeof activityScanFieldTypeSchema>;
export type DuplicateScanBehavior = z.infer<typeof duplicateScanBehaviorSchema>;
export type ActivityScanFieldValues = Record<string, string | boolean | null>;

export function createEmptyFieldValues(fields: ActivityScanField[]): ActivityScanFieldValues {
  return Object.fromEntries(
    fields.map((field) => [field.id, field.type === 'TOGGLE' ? false : null])
  );
}

export function parseActivityScanFields(value: unknown): ActivityScanField[] {
  let normalized = value;
  if (typeof normalized === 'string') {
    try {
      normalized = JSON.parse(normalized) as unknown;
    } catch {
      return [];
    }
  }
  const parsed = activityScanFieldsSchema.safeParse(normalized);
  return parsed.success ? parsed.data : [];
}

export function generateActivityScanFieldId(): string {
  return `f_${Math.random().toString(36).slice(2, 10)}`;
}
